import React, { Component } from 'react';
import Responsibility from '../Responsibility';
import CultureSubNav from './CultureSubNav';

class DiversityCareers extends Component {
    render() {
        return (
            <div>
                <div className="below-fixed-subnav">
                    <Responsibility />
                </div>
            </div>
        );
    }
}

export default DiversityCareers;